export const parseLinkPath = (link: string) => {
  const prodPrefix = '/wp-admin/admin.php?page=she-form-builder&reactslug=';
  return process.env.NODE_ENV === 'development' ? link : `${prodPrefix}${link.replace(/^\//, '').replace('?', '&')}`;
}

export const lineBreakToBr = (str: string) => {
  if (str === undefined) return '';
  
  return str.replace(/\n/g, '<br>');
}

export const slashToBr = (str: string) => {
  if (str === undefined) return '';
  
  return str.replace('//', '<br>');
}

export const stripTags = (str: string) => {
  if (str === undefined) return '';
  return str.replace(/<(?:.|\n)*?>/gm, '').replaceAll('\\', '');
}

export const getYoutubeEmbedUrl = (url: string) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  if (match && match[2].length === 11) {
    return `https://www.youtube.com/embed/${match[2]}`;
  }
  return '';  
}

export const colorAdjust = (color:string, amount:number) => {
  return '#' + color.replace(/^#/, '').replace(/../g, color => ('0'+Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
}

export const mobileFull = (isMobile: boolean, desktopValue: string, mobileValue?: string) => {
  return isMobile ? mobileValue ? mobileValue : '100%' : desktopValue;
}

export const kboardDate = (date: string) => {
  const y = date.substr(0, 4);
  const m = date.substr(4, 2);
  const d = date.substr(6, 2);
  return `${y}.${m}.${d}`
}

export const contentFilter = (content: string) => {
  if (!content) return '';
  return content.replaceAll('\\', '');
}
